import { ref } from 'vue';

export default function usePopoverMenu() {
  const popoverMenuStyle = ref({});

  const calculatePosition = (source, menuElement, { marginX = 0, marginY = 0 } = {}) => {
    const isEvent = source instanceof PointerEvent;

    const elementBounds = isEvent ? source.target.getBoundingClientRect() : source?.getBoundingClientRect();

    const menuBounds = menuElement?.getBoundingClientRect();

    const SAFE_MARGIN = 10;

    const menuHeightAfterMargin = (menuBounds?.height ?? 0) + marginY + SAFE_MARGIN;
    const menuWidthAfterMargin = (menuBounds?.width ?? 0) + marginX + SAFE_MARGIN;

    let popoverTop = 0;
    let popoverLeft = 0;

    if (elementBounds.top + menuHeightAfterMargin > window.innerHeight) {
      popoverTop = window.innerHeight - menuHeightAfterMargin;
    } else {
      popoverTop = isEvent ? source.clientY + marginY : elementBounds.y + source.offsetHeight + marginY;
    }

    if (elementBounds.left + menuWidthAfterMargin > window.innerWidth) {
      popoverLeft = window.innerWidth - menuWidthAfterMargin;
    } else {
      popoverLeft = isEvent ? source.clientX + marginX : elementBounds.x + marginX;
    }

    popoverMenuStyle.value = {
      position: 'fixed',
      top: `${popoverTop}px`,
      left: `${popoverLeft}px`,
      'z-index': 2000
    };
  };

  return {
    popoverMenuStyle,
    calculatePosition
  };
}
